import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { Author } from "../basic/author.js";
import { getSocialShareTemplate } from "./social-share/get-social-template";
import { SocialShare } from "@quintype/components";
import {storyColor, sectionPath, getSocialShareProps, getSocialShareStyle, getHorizontalSocialShare} from '../../utils';
import { LiveblogIcon } from '../../../assets/icons/social/liveblog-icon';

class StoryHeaderCard extends React.Component {
  renderSocialShare() {
    const socialShareProps = getSocialShareProps(this.props.config, this.props.story);
    const horizontalSocialShareStyle = getHorizontalSocialShare(this.props.config);
    const socialShareStyle = getSocialShareStyle(this.props.config);
    const showHorizontal = !(this.props.textStory === 'photo-priority') || (this.props.story['story-template'] === "review") || !socialShareStyle.includes('vertical');

    return !showHorizontal ? null : <div className={`story-byline__social-share horizontal-social-share-wrapper`}>
        <SocialShare template={getSocialShareTemplate(horizontalSocialShareStyle)} {...socialShareProps} />
      </div>;
  }

  render() {
    const color = storyColor(this.props.config, this.props.story);

    const sectionColor = {
      borderBottomColor: color
    };
    const liveDisplayStyles = {
      backgroundColor: color
    }
    const authorsArray = get(this.props.story, ['authors'])
      ? get(this.props.story, ['authors'])
      : [{
        name: this.props.story['author-name'],
        id: this.props.story['author-id']
      }];
    const publishedTime = this.props.story['last-published-at'] ? this.props.story['last-published-at'] : this.props.story['first-published-at'];
    const sponsoredContent = get(this.props, ['story', 'metadata', 'sponsored-by']);

    return <header className="story-header">
      {sponsoredContent && <p className="sponsored-story" data-sponsored-by="true">Sponsored by {sponsoredContent}</p>}
      <Link data-story-section-name="true" className="story-section"
        href={"/" + sectionPath(this.props.config, this.props.story.sections[0])}
        style={sectionColor}>
        {this.props.story.sections[0]['display-name'] || this.props.story.sections[0]['name']}
      </Link>
      <div>
        {(this.props.story['story-template'] === "live-blog") &&
          <div className="live-story-wrapper">
            <LiveblogIcon color={'#fff'}  stroke={'#fff'}/>
            <span className="live-story">live</span>
          </div>
        }
        <h1 className="story-headline"><bdi dangerouslySetInnerHTML={{ __html: this.props.story.headline }}></bdi></h1>
      </div>
      <p className="story-summary"><bdi dangerouslySetInnerHTML={{ __html: this.props.story.subheadline }}></bdi></p>
      <div className="story-byline">
        <div className="story-byline__author_time">
          <Author config={this.props.config} authors={authorsArray} isLink showDateOnly date={publishedTime} textStory={this.props.textStory} />
        </div>
        { this.renderSocialShare() }
      </div>
    </header>
  }
}

export { StoryHeaderCard };
